import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import f from "./styles/index.cssr.js";
import a from "../../_mixins/use-config.js";
import u from "../../_mixins/use-style.js";
import { useRtl as g } from "../../_mixins/use-rtl.js";
import o from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import { formatLength as n } from "../../_utils/css/format-length.js";
import { createInjectionKey as c } from "../../_utils/vue/create-injection-key.js";
import { defineComponent as y, provide as d, h } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { toRef as p } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const R = c("n-row"), w = {
  gutter: {
    type: [Array, Number, String],
    default: 0
  },
  alignItems: String,
  justifyContent: String
}, E = y({
  name: "Row",
  props: w,
  setup(r) {
    const {
      mergedClsPrefixRef: e,
      mergedRtlRef: l
    } = a(r);
    u("-legacy-grid", f, e);
    const m = g("Row", l, e), s = o(() => {
      const {
        gutter: t
      } = r;
      return Array.isArray(t) && t[1] || 0;
    }), i = o(() => {
      const {
        gutter: t
      } = r;
      return Array.isArray(t) ? t[0] : Number(t);
    });
    return d(R, {
      mergedClsPrefixRef: e,
      gutterRef: p(r, "gutter"),
      verticalGutterRef: s,
      horizontalGutterRef: i
    }), {
      mergedClsPrefix: e,
      rtlEnabled: m,
      styleMargin: o(() => `-${n(s.value, {
        c: 0.5
      })} -${n(i.value, {
        c: 0.5
      })}`),
      styleWidth: o(() => `calc(100% + ${n(i.value)})`)
    };
  },
  render() {
    return h("div", {
      class: [`${this.mergedClsPrefix}-row`, this.rtlEnabled && `${this.mergedClsPrefix}-row--rtl`],
      style: {
        margin: this.styleMargin,
        width: this.styleWidth,
        alignItems: this.alignItems,
        justifyContent: this.justifyContent
      }
    }, this.$slots);
  }
});
export {
  E as default,
  R as rowInjectionKey,
  w as rowProps
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/legacy-grid/src/Row.js
// module id = 107
// module chunks = 67